export default __webpack_public_path__ + "static/media/woman_98.d327890d.png";